export const WindowSizes = {
  controlBarHeight: 30,
  minWidth: 50,
  minHeight: 30,
};
